// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"main_itemsContainer__120Md"};